import React from 'react';
import ArtistContentMainName from "./artist-content-main-name";
import ArtistContentMainCredits from "./artist-content-main-credits";
import ArtistContentMainTitle from "./artist-content-main-title";
import ArtistContentMainQuote from "./artist-content-main-quote";
import ArtistContentMainLink from "./artist-content-main-link";

const ArtistContentMainContainer  = (props:any) => {
    const item = props.item;
return (
    <div>
        <ArtistContentMainName artistName={item.artistName} link={item.link}/>
        <ArtistContentMainTitle artistTitle={item.artistTitle}/>
        <ArtistContentMainCredits artistCredits={item.credits}/>
        <ArtistContentMainQuote artistQuote={item.quote}/>
        {
            item.link !== '' &&
                <ArtistContentMainLink artistLink={item.link}/>
        }
    </div>
)
}

export default ArtistContentMainContainer;